module.exports = __webpack_public_path__ + "img/icon_tel.1e67d1c7.png";